<template>
    <div>

        <!-- Intervenants -->
        <h1 class="label">Frais de mission</h1>

        <a href="https://www.urssaf.fr/portail/home/taux-et-baremes/frais-professionnels/indemnite-de-petit-deplacement/repas.html"
           target="_blank">
            Détails
        </a>

        <div class="level">
            <b-button class="is-primary" @click="isAddModalActive = true">
                Ajouter un frais de mission
            </b-button>
            <b-button class="is-warning" @click="deleteAllFM">
                Supprimer tous les frais de mission
            </b-button>
        </div>

        <b-table :data="fm">
            <template>
                <b-table-column field="fm" label="Frais" width="300" sortable
                                v-slot="props">
                    {{ props.row.fm }}
                </b-table-column>

                <b-table-column field="nbunits" label="Unité(s)" sortable v-slot="props">
                    {{ props.row.nbunits }}
                </b-table-column>

                <b-table-column field="cost" label="Coût" sortable v-slot="props">
                    {{ props.row.cost }} € TTC
                </b-table-column>

                <b-table-column field="devis" label="N° de devis" v-slot="props">
                    {{ props.row.devis }}
                </b-table-column>

                <b-table-column field="comment" label="Commentaire" v-slot="props">
                    {{ props.row.comment || '_____________'}}
                </b-table-column>

                <b-table-column label="Editer" v-slot="props">
                    <b-button
                            type="is-warning"
                            icon-left="pen"
                            @click="openEditModal(props.row)"
                    ></b-button>
                </b-table-column>

                <b-table-column label="Supprimer" v-slot="props">
                    <b-button
                            type="is-danger"
                            icon-left="trash"
                            @click="deleteFM(props.row)"
                    ></b-button>
                </b-table-column>

                <!-- Footer -->
                <template slot="footer">
                    <th style="width:40px">
                        <div class="th-wrap is-numeric"> Nb. de frais : {{ fm.length }}</div>
                    </th>
                    <th></th>
                    <th>
                        <div class="th-wrap"> Total : {{ totalCost }} €</div>
                    </th>
                </template>

            </template>
        </b-table>

        <b-modal :active.sync="isEditModalActive" has-modal-card>
            <FMEditModal
                    :refFrais="refFraisTemp"
                    :uuid="this.selectedLine.uuid"
                    :fm=this.selectedLine.fm
                    :nbunits=this.selectedLine.nbunits
                    :devis=this.selectedLine.devis
                    :comment=this.selectedLine.comment
                    :cost=this.selectedLine.cost
                    @edit-fm="onEditFM"
            ></FMEditModal>
        </b-modal>

        <b-modal :active.sync="isAddModalActive" has-modal-card>
            <FMAddModal
                    @add-fm="onAddFM"
                    :refFrais="refFraisTemp"
            ></FMAddModal>
        </b-modal>
    </div>

</template>

<script>
    import FMEditModal from "@/components/FMEditModal";
    import FMAddModal from "@/components/FMAddModal";
    import {v4 as uuidv4} from 'uuid';

    export default {
        name: "FraisMission",
        components: {FMEditModal, FMAddModal},
        mounted() {
            if (localStorage.getItem("fm")) {
                this.fm = JSON.parse(localStorage.getItem("fm"));
            } else {
                this.fm = [];
            }
          this.$axios.get('ref/project', {})
              .then((res) => {
                // console.log(res)
                this.refFraisTemp = res.data.project.ref.baremes;
              })
        },
        computed: {
            totalCost() {
                let sum = this.fm.reduce((acc, cur) => acc + Number(cur.cost), 0);
                this.$emit('updateProjectFraisCost', sum);
                return sum
            },
        },
        methods: {
            openEditModal(line) {
                this.selectedLine = line;
                this.isEditModalActive = true;
            },
            onAddFM(item) {
                // Add the item to the array
                this.fm.push({
                    uuid: uuidv4(),
                    fm: item.fm,
                    nbunits: item.nbunits,
                    cost: item.cost,
                    devis: item.devis,
                    comment: item.comment
                });
                // save the updated array in localstorage
                this.saveLocalStorageFM();
                this.isAddModalActive = false;
            },
            onEditFM(item) {
                const fmi = this.findFM(item);
                // Apply the updated values
                fmi.cost = item.cost;
                fmi.nbunits = item.nbunits;
                fmi.devis = item.devis;
                fmi.comment = item.comment;
                // save the updated array in localstorage
                this.saveLocalStorageFM();
                // close the modal
                this.isEditModalActive = false;
            },
            deleteFM(item) {
                this.$buefy.dialog.confirm({
                    title: `Supprimer la ligne`,
                    confirmText: "Supprimer la ligne",
                    type: "is-danger",
                    hasIcon: true,
                    message: `Etes-vous sûr de supprimer cette ligne ? Cette action ne pourra être annulée.`,
                    onConfirm: () => {
                        // find in the array and remove
                        const index = this.fm.indexOf(item);
                        this.fm.splice(index, 1);
                        // save the updated array in localstorage
                        this.saveLocalStorageFM();
                    }
                });
            },
            deleteAllFM() {
                this.$buefy.dialog.confirm({
                    title: `Supprimer tous les salariés`,
                    confirmText: "Oui, je confirme",
                    type: "is-danger",
                    hasIcon: true,
                    message: `Etes-vous sûr de vouloir supprimer l'ensemble des salariés ? Cette action ne pourra pas être annulée`,
                    onConfirm: () => {
                        this.fm = [];
                        // save the updated array in localstorage
                        this.saveLocalStorageFM();
                    }
                });
            },
            findFM(item) {
                return this.fm.find(fmi => fmi.uuid === item.uuid);
            },
            saveLocalStorageFM() {
                localStorage.setItem("fm", JSON.stringify(this.fm));
                this.fm = JSON.parse(localStorage.getItem("fm"));
            }
        },
        data() {
            return {
                fm: [],
                refFraisTemp: [],
                isEditModalActive: false,
                selectedLine: {},
                isAddModalActive: false,
            }
        },
    }
</script>

<style scoped>

</style>
